"use strict";

var _interopRequireDefault = require("D:/a2/Code_New/Web/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.loginByUsername = loginByUsername;
exports.verifyCode = verifyCode;
exports.logout = logout;
exports.getUserInfo = getUserInfo;

var _request = _interopRequireDefault(require("@/utils/request"));

function loginByUsername(username, password, userType, verifyCode) {
  var data = {
    username: username,
    password: password,
    userType: userType,
    verifyCode: verifyCode
  };
  return (0, _request.default)({
    url: '/auth/login',
    method: 'post',
    data: data
  });
}

function verifyCode() {
  return (0, _request.default)({
    url: '/auth/verifyCode',
    method: 'get',
    responseType: 'blob'
  });
}

function logout() {
  return (0, _request.default)({
    url: '/auth/logout',
    method: 'post'
  });
}

function getUserInfo(token) {
  return (0, _request.default)({
    url: '/auth/info',
    method: 'get',
    params: {
      token: token
    }
  });
}